// import React, { useContext } from "react";
// import { useNavigate } from "react-router-dom";

import { removeToken, removeRefreshToken } from "utils/TokenUtils";
import { removeUser } from "utils/UserLocalStorageUtils";

import { UserTypeContext } from "contexts/UserTypeContext";

const UNAUTHENTICATED = "unAuthenticated";

export default function SignOutService() {
  // const { userTypes, changeType } = useContext(UserTypeContext);
  // const navigator = useNavigate();
  // // removeToken();
  // // removeRefreshToken();
  // // removeUser();
  // localStorage.clear();
  // changeType(UNAUTHENTICATED);
  // navigator("/");

  // if (userTypes === UNAUTHENTICATED) {
  //   return;
  // }

  const userType = localStorage.getItem("userType");

  localStorage.clear();
  if (userType !== UNAUTHENTICATED) {
    window.location.href = "/";
  }
}
